import { useCallback } from 'react';
import { prop } from 'ramda';
import { useComponentConfig } from 'js/hooks/component';

import { useDynamicReducerSelector } from '../store';

export const useGetFieldId = () => {
    const { componentId } = useComponentConfig();
    const formId = useDynamicReducerSelector(prop('formId'));

    return useCallback((fieldId: string): string => `${componentId}_${formId}_${fieldId}`, [componentId, formId]);
};
